import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CircularLoaderComponent } from './circular-loader.component';
import { GlobalLoaderComponent } from './global-loader.component';

@NgModule({
  imports: [CommonModule, TranslateModule],
  declarations: [CircularLoaderComponent, GlobalLoaderComponent],
  exports: [CircularLoaderComponent, GlobalLoaderComponent]
})
export class AppLoadingModule {}
